import { useAppSelector } from 'hooks';

import { AuthTags } from '~constants/authTags';
import { selectUserTags } from '~main/selectors/login';

// TAV-2053 gate: only users with `supportathome-claims:Admin` (derived from
// `unlocking_permissions` on Accounts users) may manually transition a client
// invoice status. Same tag as Claim.tsx finalise/unfinalise — keeps the
// SaH admin-action surface consistent. Surfaces using this hook should hide /
// disable any control that would call the status mutations.
export const useCanManageInvoiceStatus = (): boolean => {
  const tags = useAppSelector(selectUserTags);
  return tags.includes(AuthTags.SUPPORTATHOME.CLAIMS.ADMIN);
};
